import apiConfig from "../config/api";
import { store } from "../config/store";
import { get } from "../helpers/request";

const getToken = () => localStorage.getItem("AccessToken");

const getHeader = () => {
  const state = store.getState();

  const header = new Headers({
    "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
    Authorization: `Bearer ${getToken()}`,
    USER_ACCESS: JSON.stringify({ companyRut: state.global.companyId }),
  });

  return header;
};

//export const examsList = () => get(`${apiConfig.apiUri}api/sel/poolsExams`);
export const examsList = () => get(`${apiConfig.apiUri}api/sel/exam/all`);

export const getAllPools = () => {
  return fetch(`${apiConfig.apiUri}api/sel/pools/all`, {
    method: "GET",
    headers: getHeader(),
  });
};

export const getPoolById = (id) => {
  return fetch(`${apiConfig.apiUri}api/sel/pools/${id}`, {
    method: "GET",
    headers: getHeader(),
  });
};

export const deletePoolById = (id) => {
  return fetch(`${apiConfig.apiUri}api/sel/pools/${id}`, {
    method: "DELETE",
    headers: getHeader(),
  });
};

export const updatePoolById = (data) => {
  return fetch(`${apiConfig.apiUri}api/sel/pools`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data)
  });
};

export const createPool = (data) => {
  return fetch(`${apiConfig.apiUri}api/sel/pools`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apiConfig.OcpApimSubscriptionKey,
      Authorization: `Bearer ${getToken()}`,
    },
    body: JSON.stringify(data)
  });
};
